<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Fiscais no mapa
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Mostra a
        strong  última posição conhecida
        |  dos fiscais no mapa e permite abrir o
        strong  histórico
        |  de localizações de um fiscal.

      .toast.toast-primary
        | Exige a permissão
        strong  Usuários GEO`s
        | .

      h5.h5 1. Abrir Fiscais no mapa
      ol
        li Em
          strong  Consultas
          | , clique em
          strong  Fiscais no mapa
          | .
      figure.manual-figure
        img(:src="imgMapa" alt="Mapa com posicionamento dos fiscais")

      h5.h5 2. Localizar um fiscal
      ol
        li Digite o
          strong  Nome do fiscal
          |  no campo acima do mapa para filtrar os pins.
        li Clique em um
          strong  pin
          |  no mapa para ver o nome e a data da posição.
        li No info-window, clique em
          strong  Abrir histórico
          | .

      h5.h5 3. Histórico do fiscal
      p
        | A tela de histórico mostra o nome do fiscal, o intervalo dos
        |  registros carregados e um mapa com as posições da página atual.
      figure.manual-figure
        img(:src="imgHistorico" alt="Histórico de posições do fiscal")
      ol
        li Ajuste quantos registros carregar por vez (ex.: 50).
        li Use
          strong  Mais recentes
          |  /
          strong  Mais antigas
          |  para navegar no tempo.
        li Clique nos pins para ver data/hora de cada posição.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMapa: require("@/assets/manuais/25-consultas-fiscais-mapa.png"),
      imgHistorico: require("@/assets/manuais/25a-consultas-fiscais-historico.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
